import { default as aboutvOCiVXoL6ZMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue?macro=true";
import { default as _91article_93DLLEG36ZqJMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue?macro=true";
import { default as index4SfAcXNV6aMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue?macro=true";
import { default as _91id_93QpIfGdz7tmMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue?macro=true";
import { default as compareBs6ad1q2CsMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue?macro=true";
import { default as contactsab6xvQ5jNwMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue?macro=true";
import { default as developersxbaWKkUeGhMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue?macro=true";
import { default as _91article_934ZRq0iAKOoMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue?macro=true";
import { default as indexB9NxwN543gMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue?macro=true";
import { default as faqmNYDAAnDOPMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue?macro=true";
import { default as indexH9a7qJ7PyrMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue?macro=true";
import { default as indexXykazfki3XMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue?macro=true";
import { default as partnerszgKMxuTXb0Meta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue?macro=true";
import { default as corporateDvjGUtFABOMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue?macro=true";
import { default as indexcTNcA2By9SMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue?macro=true";
import { default as mobile6XdTqCpy8oMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue?macro=true";
import { default as residentFOIW4fskjcMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue?macro=true";
import { default as proxyt3dvs7pqIAMeta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue?macro=true";
import { default as testNBTAfykN76Meta } from "/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue?macro=true";
import { default as component_45stubBK5imDXlo9Meta } from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubBK5imDXlo9 } from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___en___default",
    path: "/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___ar",
    path: "/ar/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___cs",
    path: "/cs/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___da",
    path: "/da/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___bg",
    path: "/bg/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___nl",
    path: "/nl/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___et",
    path: "/et/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___de",
    path: "/de/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___uk",
    path: "/uk/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___tr",
    path: "/tr/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___zh",
    path: "/zh/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___pt",
    path: "/pt/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___fi",
    path: "/fi/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___fr",
    path: "/fr/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___el",
    path: "/el/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___hu",
    path: "/hu/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___id",
    path: "/id/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___it",
    path: "/it/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___ja",
    path: "/ja/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___ko",
    path: "/ko/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___lv",
    path: "/lv/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___lt",
    path: "/lt/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___nb",
    path: "/nb/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___ro",
    path: "/ro/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___sk",
    path: "/sk/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___sl",
    path: "/sl/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "about___sv",
    path: "/sv/about",
    meta: aboutvOCiVXoL6ZMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/about.vue")
  },
  {
    name: "blog-article___en___default",
    path: "/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___en",
    path: "/en/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___ar",
    path: "/ar/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___ru",
    path: "/ru/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___cs",
    path: "/cs/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___da",
    path: "/da/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___bg",
    path: "/bg/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___nl",
    path: "/nl/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___et",
    path: "/et/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___de",
    path: "/de/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___uk",
    path: "/uk/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___es",
    path: "/es/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___tr",
    path: "/tr/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___zh",
    path: "/zh/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___pt",
    path: "/pt/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___fi",
    path: "/fi/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___fr",
    path: "/fr/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___el",
    path: "/el/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___hu",
    path: "/hu/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___id",
    path: "/id/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___it",
    path: "/it/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___ja",
    path: "/ja/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___ko",
    path: "/ko/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___lv",
    path: "/lv/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___lt",
    path: "/lt/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___nb",
    path: "/nb/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___pl",
    path: "/pl/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___ro",
    path: "/ro/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___sk",
    path: "/sk/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___sl",
    path: "/sl/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog-article___sv",
    path: "/sv/blog/:article()",
    meta: _91article_93DLLEG36ZqJMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/[article].vue")
  },
  {
    name: "blog___en___default",
    path: "/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___ar",
    path: "/ar/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___cs",
    path: "/cs/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___da",
    path: "/da/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___bg",
    path: "/bg/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___et",
    path: "/et/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___uk",
    path: "/uk/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___tr",
    path: "/tr/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___pt",
    path: "/pt/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___fi",
    path: "/fi/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___el",
    path: "/el/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___hu",
    path: "/hu/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___id",
    path: "/id/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___ja",
    path: "/ja/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___ko",
    path: "/ko/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___lv",
    path: "/lv/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___lt",
    path: "/lt/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___nb",
    path: "/nb/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___pl",
    path: "/pl/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___ro",
    path: "/ro/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___sk",
    path: "/sk/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___sl",
    path: "/sl/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "blog___sv",
    path: "/sv/blog",
    meta: index4SfAcXNV6aMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/blog/index.vue")
  },
  {
    name: "c-id___en___default",
    path: "/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___en",
    path: "/en/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___ar",
    path: "/ar/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___ru",
    path: "/ru/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___cs",
    path: "/cs/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___da",
    path: "/da/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___bg",
    path: "/bg/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___nl",
    path: "/nl/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___et",
    path: "/et/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___de",
    path: "/de/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___uk",
    path: "/uk/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___es",
    path: "/es/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___tr",
    path: "/tr/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___zh",
    path: "/zh/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___pt",
    path: "/pt/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___fi",
    path: "/fi/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___fr",
    path: "/fr/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___el",
    path: "/el/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___hu",
    path: "/hu/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___id",
    path: "/id/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___it",
    path: "/it/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___ja",
    path: "/ja/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___ko",
    path: "/ko/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___lv",
    path: "/lv/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___lt",
    path: "/lt/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___nb",
    path: "/nb/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___pl",
    path: "/pl/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___ro",
    path: "/ro/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___sk",
    path: "/sk/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___sl",
    path: "/sl/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "c-id___sv",
    path: "/sv/c/:id()",
    meta: _91id_93QpIfGdz7tmMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/c/[id].vue")
  },
  {
    name: "compare___en___default",
    path: "/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___en",
    path: "/en/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___ar",
    path: "/ar/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___ru",
    path: "/ru/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___cs",
    path: "/cs/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___da",
    path: "/da/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___bg",
    path: "/bg/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___nl",
    path: "/nl/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___et",
    path: "/et/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___de",
    path: "/de/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___uk",
    path: "/uk/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___es",
    path: "/es/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___tr",
    path: "/tr/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___zh",
    path: "/zh/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___pt",
    path: "/pt/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___fi",
    path: "/fi/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___fr",
    path: "/fr/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___el",
    path: "/el/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___hu",
    path: "/hu/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___id",
    path: "/id/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___it",
    path: "/it/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___ja",
    path: "/ja/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___ko",
    path: "/ko/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___lv",
    path: "/lv/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___lt",
    path: "/lt/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___nb",
    path: "/nb/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___pl",
    path: "/pl/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___ro",
    path: "/ro/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___sk",
    path: "/sk/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___sl",
    path: "/sl/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "compare___sv",
    path: "/sv/compare",
    meta: compareBs6ad1q2CsMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/compare.vue")
  },
  {
    name: "contacts___en___default",
    path: "/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___ar",
    path: "/ar/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___ru",
    path: "/ru/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___cs",
    path: "/cs/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___da",
    path: "/da/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___bg",
    path: "/bg/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___nl",
    path: "/nl/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___et",
    path: "/et/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___de",
    path: "/de/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___uk",
    path: "/uk/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___es",
    path: "/es/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___tr",
    path: "/tr/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___zh",
    path: "/zh/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___pt",
    path: "/pt/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___fi",
    path: "/fi/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___fr",
    path: "/fr/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___el",
    path: "/el/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___hu",
    path: "/hu/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___id",
    path: "/id/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___it",
    path: "/it/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___ja",
    path: "/ja/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___ko",
    path: "/ko/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___lv",
    path: "/lv/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___lt",
    path: "/lt/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___nb",
    path: "/nb/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___pl",
    path: "/pl/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___ro",
    path: "/ro/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___sk",
    path: "/sk/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___sl",
    path: "/sl/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "contacts___sv",
    path: "/sv/contacts",
    meta: contactsab6xvQ5jNwMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/contacts.vue")
  },
  {
    name: "developers___en___default",
    path: "/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___en",
    path: "/en/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___ar",
    path: "/ar/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___ru",
    path: "/ru/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___cs",
    path: "/cs/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___da",
    path: "/da/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___bg",
    path: "/bg/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___nl",
    path: "/nl/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___et",
    path: "/et/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___de",
    path: "/de/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___uk",
    path: "/uk/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___es",
    path: "/es/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___tr",
    path: "/tr/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___zh",
    path: "/zh/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___pt",
    path: "/pt/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___fi",
    path: "/fi/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___fr",
    path: "/fr/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___el",
    path: "/el/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___hu",
    path: "/hu/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___id",
    path: "/id/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___it",
    path: "/it/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___ja",
    path: "/ja/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___ko",
    path: "/ko/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___lv",
    path: "/lv/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___lt",
    path: "/lt/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___nb",
    path: "/nb/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___pl",
    path: "/pl/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___ro",
    path: "/ro/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___sk",
    path: "/sk/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___sl",
    path: "/sl/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: "developers___sv",
    path: "/sv/developers",
    meta: developersxbaWKkUeGhMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/developers.vue")
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___en___default",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___en___default",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/en/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___en",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___en",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/ar/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___ar",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___ar",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/ru/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___ru",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___ru",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/cs/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___cs",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___cs",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/da/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___da",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___da",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/bg/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___bg",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___bg",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/nl/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___nl",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___nl",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/et/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___et",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___et",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/de/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___de",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___de",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/uk/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___uk",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___uk",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/es/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___es",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___es",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/tr/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___tr",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___tr",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/zh/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___zh",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___zh",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/pt/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___pt",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___pt",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/fi/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___fi",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___fi",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/fr/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___fr",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___fr",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/el/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___el",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___el",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/hu/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___hu",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___hu",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/id/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___id",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___id",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/it/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___it",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___it",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/ja/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___ja",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___ja",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/ko/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___ko",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___ko",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/lv/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___lv",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___lv",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/lt/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___lt",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___lt",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/nb/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___nb",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___nb",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/pl/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___pl",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___pl",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/ro/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___ro",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___ro",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/sk/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___sk",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___sk",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/sl/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___sl",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___sl",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: faqmNYDAAnDOPMeta?.name,
    path: "/sv/faq",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq.vue"),
    children: [
  {
    name: "faq-article___sv",
    path: ":article()",
    meta: _91article_934ZRq0iAKOoMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/[article].vue")
  },
  {
    name: "faq___sv",
    path: "",
    meta: indexB9NxwN543gMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/faq/index.vue")
  }
]
  },
  {
    name: "geo___en___default",
    path: "/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___en",
    path: "/en/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___ar",
    path: "/ar/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___ru",
    path: "/ru/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___cs",
    path: "/cs/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___da",
    path: "/da/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___bg",
    path: "/bg/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___nl",
    path: "/nl/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___et",
    path: "/et/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___de",
    path: "/de/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___uk",
    path: "/uk/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___es",
    path: "/es/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___tr",
    path: "/tr/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___zh",
    path: "/zh/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___pt",
    path: "/pt/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___fi",
    path: "/fi/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___fr",
    path: "/fr/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___el",
    path: "/el/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___hu",
    path: "/hu/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___id",
    path: "/id/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___it",
    path: "/it/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___ja",
    path: "/ja/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___ko",
    path: "/ko/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___lv",
    path: "/lv/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___lt",
    path: "/lt/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___nb",
    path: "/nb/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___pl",
    path: "/pl/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___ro",
    path: "/ro/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___sk",
    path: "/sk/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___sl",
    path: "/sl/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "geo___sv",
    path: "/sv/geo",
    meta: indexH9a7qJ7PyrMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/geo/index.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___et",
    path: "/et",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___el",
    path: "/el",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___lv",
    path: "/lv",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___lt",
    path: "/lt",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___nb",
    path: "/nb",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___sl",
    path: "/sl",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    meta: indexXykazfki3XMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/index.vue")
  },
  {
    name: "partners___en___default",
    path: "/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___ar",
    path: "/ar/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___ru",
    path: "/ru/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___cs",
    path: "/cs/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___da",
    path: "/da/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___bg",
    path: "/bg/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___nl",
    path: "/nl/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___et",
    path: "/et/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___de",
    path: "/de/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___uk",
    path: "/uk/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___es",
    path: "/es/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___tr",
    path: "/tr/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___zh",
    path: "/zh/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___pt",
    path: "/pt/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___fi",
    path: "/fi/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___fr",
    path: "/fr/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___el",
    path: "/el/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___hu",
    path: "/hu/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___id",
    path: "/id/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___it",
    path: "/it/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___ja",
    path: "/ja/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___ko",
    path: "/ko/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___lv",
    path: "/lv/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___lt",
    path: "/lt/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___nb",
    path: "/nb/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___pl",
    path: "/pl/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___ro",
    path: "/ro/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___sk",
    path: "/sk/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___sl",
    path: "/sl/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: "partners___sv",
    path: "/sv/partners",
    meta: partnerszgKMxuTXb0Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/partners.vue")
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___en___default",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___en___default",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___en___default",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___en___default",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/en/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___en",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___en",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___en",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___en",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/ar/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___ar",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___ar",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___ar",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___ar",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/ru/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___ru",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___ru",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___ru",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___ru",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/cs/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___cs",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___cs",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___cs",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___cs",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/da/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___da",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___da",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___da",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___da",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/bg/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___bg",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___bg",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___bg",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___bg",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/nl/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___nl",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___nl",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___nl",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___nl",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/et/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___et",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___et",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___et",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___et",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/de/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___de",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___de",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___de",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___de",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/uk/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___uk",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___uk",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___uk",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___uk",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/es/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___es",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___es",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___es",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___es",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/tr/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___tr",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___tr",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___tr",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___tr",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/zh/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___zh",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___zh",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___zh",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___zh",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/pt/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___pt",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___pt",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___pt",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___pt",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/fi/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___fi",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___fi",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___fi",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___fi",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/fr/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___fr",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___fr",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___fr",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___fr",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/el/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___el",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___el",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___el",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___el",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/hu/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___hu",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___hu",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___hu",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___hu",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/id/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___id",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___id",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___id",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___id",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/it/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___it",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___it",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___it",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___it",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/ja/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___ja",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___ja",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___ja",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___ja",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/ko/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___ko",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___ko",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___ko",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___ko",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/lv/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___lv",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___lv",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___lv",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___lv",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/lt/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___lt",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___lt",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___lt",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___lt",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/nb/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___nb",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___nb",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___nb",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___nb",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/pl/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___pl",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___pl",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___pl",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___pl",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/ro/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___ro",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___ro",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___ro",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___ro",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/sk/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___sk",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___sk",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___sk",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___sk",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/sl/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___sl",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___sl",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___sl",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___sl",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: proxyt3dvs7pqIAMeta?.name,
    path: "/sv/proxy",
    meta: proxyt3dvs7pqIAMeta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy.vue"),
    children: [
  {
    name: "proxy-corporate___sv",
    path: "corporate",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/corporate.vue")
  },
  {
    name: "proxy___sv",
    path: "",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/index.vue")
  },
  {
    name: "proxy-mobile___sv",
    path: "mobile",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/mobile.vue")
  },
  {
    name: "proxy-resident___sv",
    path: "resident",
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/proxy/resident.vue")
  }
]
  },
  {
    name: "test___en___default",
    path: "/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___ar",
    path: "/ar/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___ru",
    path: "/ru/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___cs",
    path: "/cs/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___da",
    path: "/da/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___bg",
    path: "/bg/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___nl",
    path: "/nl/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___et",
    path: "/et/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___de",
    path: "/de/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___uk",
    path: "/uk/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___es",
    path: "/es/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___tr",
    path: "/tr/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___zh",
    path: "/zh/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___pt",
    path: "/pt/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___fi",
    path: "/fi/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___fr",
    path: "/fr/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___el",
    path: "/el/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___hu",
    path: "/hu/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___id",
    path: "/id/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___it",
    path: "/it/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___ja",
    path: "/ja/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___ko",
    path: "/ko/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___lv",
    path: "/lv/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___lt",
    path: "/lt/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___nb",
    path: "/nb/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___pl",
    path: "/pl/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___ro",
    path: "/ro/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___sk",
    path: "/sk/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___sl",
    path: "/sl/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: "test___sv",
    path: "/sv/test",
    meta: testNBTAfykN76Meta || {},
    component: () => import("/disk2/server/proxy-front-ssr/dists/sx/pages/test.vue")
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/index-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/en-US-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/ar-AE-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/ru-RU-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/cs-CS-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/da-DK-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/bg-BG-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/nl-NL-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/et-EE-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/de-DE-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/uk-UA-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/es-ES-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/tr-TR-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/zh-CN-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/pt-PT-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/fi-FI-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/fr-FR-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/el-GR-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/hu-HU-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/id-ID-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/it-IT-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/ja-JP-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/ko-KR-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/lv-LV-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/lt-LT-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/nb-NO-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/pl-PL-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/ro-RO-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/sk-SK-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/sl-SI-sitemap.xml",
    component: component_45stubBK5imDXlo9
  },
  {
    name: component_45stubBK5imDXlo9Meta?.name,
    path: "/sv-SV-sitemap.xml",
    component: component_45stubBK5imDXlo9
  }
]